import AttendancePage from '../../components/attendancePage';

const TrainerAttendance = () => (
  <AttendancePage userType="coach" title="Trainer Attendance" />
);

export default TrainerAttendance;
